import script from "./StakingFundCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./StakingFundCard.vue?vue&type=script&setup=true&lang=ts"

import "./StakingFundCard.vue?vue&type=style&index=0&id=43dcffb8&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43dcffb8"]])

export default __exports__